import SearchLandingPage from '@/components/modules/Landing/SearchLandingPage';
import { searchLandingPages } from '@/content/searchLandingPages';

const InternalAiKnowledgeBasePage = () => (
  <SearchLandingPage config={searchLandingPages.internalAiKnowledgeBase} />
);

export default InternalAiKnowledgeBasePage;
